import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'baq72',
  Description:
    'Here\'s all the online content included with your <strong>Biology Exam Practice Workbook</strong>.',
  Credits:
    `<p><strong>Exam Practice Questions</strong></p>
<p>
With thanks to Lauren Burns for the proofreading.<br>
Clipart from Corel &reg;<br>
Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk<br>
</p>
<p>
Graph of plaques in mice brains reprinted from <em>Journal of Alzheimer&rsquo;s Disease</em>, 28, Bohrmann et al, <em>Gantenerumab: A Novel Human Anti-Ab Antibody Demonstrates Sustained Cerebral Amyloid-b Binding and Elicits Cell-Mediated Removal of Human Amyloid-b</em>, pages 49-69, copyright 2012, with permission from IOS Press.
</p>
<p>
Graph of number of death certificates in Great Britain contains public sector information published by the Health and Safety Executive and licensed under the Open Government Licence.
</p>
<p>
Table on the speed of nerve impulses is based on data from <em>Conduction Velocity and Diameter of Nerve Fibers</em>, J. B. Hursh, Vol. 127, Issue 1, July 1939, pages 131-139.
</p>
<p>
Maize offspring phenotypes graph based on the data from <em>The linkage of certain aleurone and endosperm factors in maize, and their relation to other linkage groups</em> by C.B. Hutchison, published in Ithaca, N.Y.: Cornell University, 1922.
</p>
<p>
Population index of butterflies graphs based on the data from Butterfly Conservation.
</p>
<p>
Bar chart of the menstruation patterns of twins is based on the data from <em>Resemblance for Age at Menarche in Female Twins Reared Apart and Together</em> by Nancy L. Segal and Joanne Hoven Stohs. &copy; 2007 Wayne State University Press.
</p>
<p>
Every effort has been made to locate copyright holders and obtain permission to reproduce sources. For those sources where it has been difficult to trace the originator of the work, we would be grateful for information. If any copyright holder would like us to make an amendment to the acknowledgements, please notify us and we will gladly update these acknowledgements.
</p>
<p>Text, design, layout and original illustrations Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</p>`,};